<template>
  <div
    class="form-group"
    :class="{
      'has-error': errors.has(validationName),
      'form-group-active': active
    }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <textarea
      ref="textarea"
      class="form-control"
      :placeholder="placeholder"
      :rows="rows"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :required="required"
      :data-vv-as="label"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
    </textarea>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "form-group-textarea",
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    rows: Number,
    value: {
      type: [String, Number, Boolean, Object]
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupTextArea.vue